module.exports = __webpack_public_path__ + "img/myInitialEle.7a03e776.svg";